module.exports = __webpack_public_path__ + "img/inspection.cb6ac77d.svg";